<script>
import { groupBy } from "lodash";

export default {
    name: "StaffVacationTrackerTable",
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        leaveType: {
            type: String,
            required: false,
            default: "vacation",
        },
    },
    computed: {
        vacationListSortByYear() {
            const yearlyList = this.groupVacationByYear(this.vacationList);

            return this.calculateYearlyStats(yearlyList);
        },
        leaveText() {
            return this.leaveType === "vacation" ? "Vacation" : "Sick Leave";
        },
        vacationList() {
            if (this.leaveType === "vacation") {
                return this.$store.getters["vacation/vacationList"];
            } else {
                return this.$store.getters["vacation/sickLeaveList"];
            }
        },
        /*...mapGetters({
            vacationList: "vacation/vacationList",
        }),*/
    },
    mounted() {
        this.getVacationList(this.leaveType);
    },
    methods: {
        showTotalDays(vacation, type) {
            return type === "vacation" ? vacation.totalVacationDays : vacation.totalSickLeaveDays;
        },
        showApprovedDays(vacation, type) {
            return type === "vacation" ? vacation.approvedVacationsDays : vacation.approvedSickLeaveDays;
        },
        async getVacationList(leaveType) {
            await this.$store.dispatch("vacation/getStaffVacations", { staffId: this.staffId, leaveType: leaveType });
        },
        groupVacationByYear(vacationList, yearField = "start_year") {
            return groupBy(vacationList, yearField);
        },
        calculateYearlyStats(vacations) {
            const yearlyStats = {};

            for (const year in vacations) {
                const vacationList = vacations[year];
                const totalVacationDays = vacationList[0].total_vacation_days;
                const totalSickLeaveDays = vacationList[0].total_sick_leave_days;
                let sumOfDays = 0;
                let approvedVacationsDays = 0;
                let approvedSickLeaveDays = 0;
                let balance = 0;
                let encash = vacationList[0].staff_encash_days;
                let finalBalance = 0;

                for (const vacation of vacationList) {
                    sumOfDays += vacation.total_days;

                    if (vacation.is_approved === 1) {
                        if (vacation.sick_leave === 1) {
                            approvedSickLeaveDays += vacation.total_days;
                        } else {
                            approvedVacationsDays += vacation.total_days;
                        }
                    }
                }

                if (vacationList[0].sick_leave === 1) {
                    balance = totalSickLeaveDays - approvedSickLeaveDays;
                } else {
                    balance = totalVacationDays - approvedVacationsDays;
                }
                finalBalance = balance - encash;

                yearlyStats[year] = {
                    totalVacationDays: totalVacationDays,
                    totalSickLeaveDays: totalSickLeaveDays,
                    approvedVacationsDays: approvedVacationsDays,
                    approvedSickLeaveDays: approvedSickLeaveDays,
                    balance: balance,
                    encash: encash,
                    finalBalance: finalBalance,
                    vacations: vacationList,
                };
            }

            return yearlyStats;
        },
    },
};
</script>

<template>
  <div
    v-if="vacationList.length"
    class="block block-rounded my-3"
  >
    <div class="block-header block-header-default">
      <h3
        class="block-title"
      >
        {{ leaveText }} Tracker for {{ vacationList[0]?.staff.user.full_name ?? "" }}
      </h3>
    </div>

    <div class="block-content">
      <div
        class="table-responsive"
      >
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Year</th>
              <th>Total</th>
              <th>Approved</th>
              <th>Balance</th>
              <th v-if="leaveType === 'vacation'">
                Encash
              </th>
              <th>Final</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(vacation, year) in vacationListSortByYear"
              :key="year"
            >
              <td>
                <a
                  v-if="leaveType === 'vacation'"
                  :href="`/admin/vacation/list/${year}?staff_id=${staffId}`"
                >{{ year }}</a>
                <a
                  v-else
                  :href="`/admin/vacation/list/${year}?staff_id=${staffId}&leave_type=sick`"
                >{{ year
                }}</a>
              </td>
              <td>{{ showTotalDays(vacation, leaveType) }}</td>
              <td>{{ showApprovedDays(vacation, leaveType) }}</td>
              <td>{{ vacation.balance }}</td>
              <td v-if="leaveType === 'vacation'">
                {{ vacation.encash }}
              </td>
              <td>{{ vacation.finalBalance }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
